import trackProductEvent from '../../utils/trackProductEvent';

const waysToWearItQuickViewTracker = new (function () {
  const pdpCanonicalName = 'pdp';

  this.trackQuickViewCtaClick = ({
    outfitId,
    source,
    collection,
    pdpSkuId,
    externalProductId,
  }) => {
    return trackProductEvent({
      eventName: 'pdp.ways_to_wear_it.outfit.modal.open',
      canonicalName: pdpCanonicalName,
      actionType: 'click',
      actionName: 'ways_to_wear_it_quickview_outfit',
      directBuyContext: {
        outfit_id: outfitId,
        source,
        collection,
        pdp_sku_id: pdpSkuId,
        external_product_id: externalProductId,
      },
    });
  };

  this.trackQuickViewPdpClick = ({
    skuId,
    outfitId,
    source,
    collection,
    pdpSkuId,
    externalProductId,
  }) => {
    return trackProductEvent({
      eventName: 'pdp.ways_to_wear_it.outfit.item.click',
      canonicalName: pdpCanonicalName,
      actionType: 'click',
      actionName: 'ways_to_wear_it_quickview_item_clicked',
      directBuyContext: {
        outfit_item_sku_id: skuId,
        outfit_id: outfitId,
        source,
        collection,
        pdp_sku_id: pdpSkuId,
        external_product_id: externalProductId,
      },
    });
  };

  this.trackQuickViewAddToBag = ({
    skuId,
    outfitId,
    source,
    collection,
    pdpSkuId,
    externalProductId,
  }) => {
    return trackProductEvent({
      eventName: 'pdp.ways_to_wear_it.outfit.item.add_to_bag',
      canonicalName: pdpCanonicalName,
      actionType: 'click',
      actionName: 'ways_to_wear_it_quickview_item_added_to_bag',
      directBuyContext: {
        outfit_item_sku_id: skuId,
        outfit_id: outfitId,
        source,
        collection,
        pdp_sku_id: pdpSkuId,
        external_product_id: externalProductId,
      },
    });
  };

  this.trackQuickViewModalView = ({
    outfitId,
    source,
    collection,
    pdpSkuId,
    externalProductId,
  }) => {
    return trackProductEvent({
      eventName: 'pdp.ways_to_wear_it.outfit.modal.view',
      canonicalName: pdpCanonicalName,
      actionType: 'view',
      actionName: 'ways_to_wear_it_quickview_outfit',
      directBuyContext: {
        outfit_id: outfitId,
        source,
        collection,
        pdp_sku_id: pdpSkuId,
        external_product_id: externalProductId,
      },
    });
  };
})();

export default waysToWearItQuickViewTracker;
